import { useLocation } from 'react-router-dom';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import { EnrolmentRouter } from '../../../util/RouterUtil';
import ViewWrapper from '../../ViewWrapper';

const EnrolmentRouterView = () => {
    const auth = AuthenticationUtil.get();
    const pathname = useLocation().pathname;

    return (
        <div className='body-view'>
            <ViewWrapper router={EnrolmentRouter} />
        </div>
    );
};

export default EnrolmentRouterView;
